import { Accordion, AccordionSummary, Stack, Typography } from '@mui/material';
import { UserDetailsQuery } from '@/__generated__/graphql';
import { UserPlatformCard } from './UserPlatformCard';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import { AccordianToggleButton } from '../styles';

type Props = {
  structures: UserDetailsQuery['userDetails']['structures'];
};
export const UserPlatforms = ({ structures }: Props) => {
  return (
    <Accordion
      disableGutters
      elevation={0}
      sx={{
        '&::before': {
          opacity: 0,
        },
        width: '100%',
        backgroundColor: '#6e819810',
        padding: '1%',
        borderRadius: '10px',
      }}
    >
      <AccordionSummary
        expandIcon={
          <AccordianToggleButton>
            <ArrowDropDown />
          </AccordianToggleButton>
        }
      >
        <Typography fontSize={16} fontWeight={700} mb={5}>
          Access to platforms
        </Typography>
      </AccordionSummary>
      <Stack gap={2}>
        {structures.map((structure) => (
          <UserPlatformCard key={structure.id} structure={structure} />
        ))}
      </Stack>
    </Accordion>
  );
};
